import { UseMutationOptions } from "@tanstack/react-query";
import { useMutationApi, useQueryApi } from "api/hooks.ts";
import { AxiosError } from "axios";
import { ApiErrorResponse } from "types/models.ts";

import { conversionStateApi } from "./api";

import GetConversionStateRequest = App.Http.Requests.ConversionState.GetConversionStateRequest;
import GetConversionStateResponse = App.Http.Responses.ConversionState.GetConversionStateResponse;
import GetConversionStatesRequest = App.Http.Requests.ConversionState.GetConversionStatesRequest;
import GetConversionStatesResponse = App.Http.Responses.ConversionState.GetConversionStatesResponse;
import BaseExportRequest = App.Http.Requests.BaseExportRequest;
import ExportResponse = App.Http.Responses.ExportResponse;

// Query to get a list of conversion states
export const useGetConversionStatesQuery = (request: GetConversionStatesRequest, options = {}) => {
    return useQueryApi<GetConversionStatesResponse>({
        queryKey: ["getConversionStates", request],
        queryFn: () => conversionStateApi.index(request),
        ...options,
    });
};

// Query to get a specific conversion state
export const useGetConversionStateQuery = (
    conversionStateId: string,
    request?: GetConversionStateRequest,
    options = {}
) => {
    return useQueryApi<GetConversionStateResponse>({
        queryKey: ["getConversionState", conversionStateId],
        queryFn: () => conversionStateApi.show(conversionStateId, request),
        ...options,
    });
};

// Mutation to export conversion states
export const useGetConversionStatesExportMutation = (
    options: UseMutationOptions<ExportResponse, AxiosError<ApiErrorResponse>, BaseExportRequest> = {}
) => {
    return useMutationApi<ExportResponse, BaseExportRequest>({
        mutationKey: ["getConversionStatesExport"],
        mutationFn: (request) => conversionStateApi.export(request),
        ...options,
    });
};
